module.exports = __webpack_public_path__ + "static/media/patch-snooze.e310606c.webp";